"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M2.1 3.51c-.39.39-.39 1.02 0 1.41l6.61 6.61-5.56 5.57q-.15.15-.15.36v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15l5.56-5.56 6.61 6.61c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L3.52 3.51c-.4-.39-1.03-.39-1.42 0m18.61 3.53c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75zm-9.1749 1.6697 2.5173-2.5173L17.8001 9.94l-2.5173 2.5173z"
}), 'EditOffRounded');